export enum EStorageKey {
  TITLE = 'title',
  THEME = 'theme',
  TOKEN = 'token',
  USER_ID = 'user_id',
  BO_TOKEN = 'token',
  BO_LOGIN_STATUS = 'BO_LOGIN_STATUS',
  LANGUAGE = 'language',
  PASSWORD = 'password',
  INDICATORS = 'indicators',
  THEME_SCHEME = 'theme_scheme',
  BALANCE_OPTIONS = 'balance_options',
  SEARCH_HISTORY = 'search_history',
  META_TRADER_ID = 'meta_trader_id',
  META_TRADER_GROUP = 'meta_trader_group',
  BIOMETRICS_ENABLE = 'biometrics_enable',
  MARKET_SUBSCRIPTION = 'market_subscription',
  LOGIN_AS = 'LOGIN_AS',
  ASK_PRICE_VISIBLE = 'ASK_PRICE_VISIBLE',
  REMEMBER_ME = 'REMEMBER_ME',
  ACCOUNT_SWITCHED = 'ACCOUNT_SWITCHED',
  VOLUME_MODE_PREFERENCE = 'VOLUME_MODE_PREFERENCE',
  FCM_TOPICS = 'FCM_TOPICS',
  SHOULD_SHOW_FEATURE_ANNOUNCEMENT_MODAL = 'SHOULD_SHOW_FEATURE_ANNOUNCEMENT_MODAL', // To show feature announcement modal once per login session , remove after showing
  TRADING_ACCOUNT_IDENTITY = 'TRADING_ACCOUNT_IDENTITY',
  SHOULD_SHOW_ALL_SYMBOL_ON_ORDER_LISTING = 'SHOULD_SHOW_ALL_SYMBOL_ON_ORDER_LISTING',
  LAST_SELECTED_SYMBOL = 'LAST_SELECTED_SYMBOL',
  INDICATOR_CUSTOM_COLORS = 'INDICATOR_CUSTOM_COLORS',
  LAST_SELECTED_SIGNAL_SYMBOL = 'LAST_SELECTED_SIGNAL_SYMBOL',
  OTP_START_TIME = 'OTP_START_TIME',
  ASSETS_FILTER_VALUES = 'ASSETS_FILTER_VALUES',
  CHART_PREVIEW_VISIBLE = 'CHART_PREVIEW_VISIBLE',
  SIGNAL_CHART_VISIBLE = 'SIGNAL_CHART_VISIBLE',
  DEEP_LINK_DATA = 'DEEP_LINK_DATA',
  IS_EAS_UPDATE_RELOAD = 'IS_EAS_UPDATE_RELOAD',
  ATTRIBUTION_DATA = 'ATTRIBUTION_DATA',
  MARKETING_PARAMS = 'MARKETING_PARAMS'
}

export interface IStorage {
  setItem: (key: EStorageKey, value: unknown) => void;
  getItem: <T = unknown>(key: EStorageKey) => T;
  removeItem: (key: EStorageKey) => void;
}
